import React, {useEffect, useState} from 'react';
import {AuthContext} from "./index";
import AuthService from "../API/AuthService";

function ContextAuth({children}) {

    const [isAuth, setIsAuth] = useState(false)

    useEffect(() => {
        AuthService.login()
            .then(() => setIsAuth(true))
    }, [])

    return (
        <AuthContext.Provider value={{
            isAuth
        }}>
            {children}
        </AuthContext.Provider>
    );
}

export default ContextAuth;